import { IUser, ITravelAgent } from "services/BackendApi";
import { ISingleSelectOption } from 'ui/SingleSelect';

export const userToOption = (user: Partial<IUser> | Partial<ITravelAgent>): ISingleSelectOption => ({
  value: user.uuid,
  label: user.firstName + ' ' + user.lastName,
});
